/** @jsx h */
import { h, Component, JSX, ComponentChildren } from 'preact';

interface LayerProps {
  children?: ComponentChildren;
  onClick?: (e: Event) => void;
  onTouchStart?: (e: Event) => void;
  zIndex?: number;
  dataZone?: string;
}

export default class Layer extends Component<LayerProps> {
  render(): JSX.Element {
    const {
      children,
      zIndex = 1,
      onClick = () => {},
      onTouchStart = () => {},
      dataZone = ''
    } = this.props;

    const style = {
      position: 'absolute' as const,
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      zIndex
    };

    return (
      <div
        onClick={onClick}
        onTouchStart={onTouchStart}
        style={style}
        data-zone={dataZone}
      >
        {children}
      </div>
    );
  }
}
